export default cb => window.requestAnimationFrame(cb)
